import Vue from 'vue';
import Router from 'vue-router';

const HomePage = () => import('@/components/home');
const SetPage = () => import('@/components/set');
const AttemptPage = () => import('@/components/attempt');
const ResultPage = () => import('@/components/result');

Vue.use(Router);

export default new Router({
	mode: 'history',
	routes: [{
        path: '/quick-practice/exam/:examSlug', 
        component: HomePage
  	}, {
		path: '/quick-practice/:setSlug/result/:setId/:attemptId',
		component: ResultPage
	}, {

		path: '/quick-practice/:setSlug/practice-more/:setId/:attemptId',
		component: ResultPage,
		props: { 
			is_result: false 
		}
	}, {
        path: '/quick-practice/exam/:examSlug/set/:setId/:attemptMode/:attemptId',
        component: AttemptPage
	},{
		path: '/quick-practice/exam/:examSlug/set/:setId',
		component: SetPage
	}]
});